module.exports = __webpack_public_path__ + "static/media/qr-primary.c727e940.svg";